
import { AxiosResponse } from 'axios'
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import { VCodeMirror } from 'vue3-code-mirror'
import useValidate from '@vuelidate/core'
import pythonDescriptor from './DatasetManagementPythonDataset.json'
import Dropdown from 'primevue/dropdown'
import Card from 'primevue/card'
import RadioButton from 'primevue/radiobutton'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import Dialog from 'primevue/dialog'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

export default defineComponent({
    components: { Card, Dropdown, VCodeMirror, RadioButton, KnValidationMessages, Dialog, DataTable, Column },
    props: { selectedDataset: { type: Object as any }, pythonEnvironments: { type: Array as any }, rEnvironments: { type: Array as any } },
    emits: ['touched'],
    computed: {
        datasetTypes(): any {
            if (this.dataset.pythonDatasetType == 'python') {
                return this.pythonEnvironments
            } else {
                return this.rEnvironments
            }
        }
    },
    data() {
        return {
            pythonDescriptor,
            v$: useValidate() as any,
            dataset: {} as any,
            codeMirrorPython: {} as any,
            pythonEnvLibs: null as any,
            libListVisible: false,
            scriptOptions: {
                theme: 'eclipse',
                lineWrapping: true,
                lineNumbers: true,
                mode: 'text/x-python'
            }
        }
    },
    created() {
        this.loadDataset()
        this.setupCodeMirror()
    },
    watch: {
        selectedDataset() {
            this.loadDataset()
        }
    },
    validations() {
        const pythonFieldsRequired = (value) => {
            return this.dataset.dsTypeCd != 'Python/R' || value
        }
        const customValidators: ICustomValidatorMap = { 'python-fields-required': pythonFieldsRequired }
        const validationObject = { dataset: createValidations('dataset', pythonDescriptor.validations.dataset, customValidators) }
        return validationObject
    },
    methods: {
        loadDataset() {
            this.dataset = this.selectedDataset
            this.dataset.pythonDatasetType ? '' : (this.dataset.pythonDatasetType = 'python')
            this.dataset.pythonScript ? '' : (this.dataset.pythonScript = '')
        },
        setupCodeMirror() {
            const interval = setInterval(() => {
                if (!this.$refs.codeMirrorPython) return
                this.codeMirrorPython = (this.$refs.codeMirrorPython as any).editor as any
                clearInterval(interval)
            }, 200)
        },
        getEnvLibraries() {
            if (this.dataset.pythonDatasetType == 'python') {
                return this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/backendservices/widgets/python/libraries/${this.dataset.pythonEnvironment.label}`)
            } else {
                return this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/backendservices/widgets/RWidget/libraries/${this.dataset.pythonEnvironment.label}`)
            }
        },
        async checkEnvironment() {
            await this.$http
            this.getEnvLibraries()
                .then((response: AxiosResponse<any>) => {
                    this.dataset.pythonDatasetType == 'python' ? (this.pythonEnvLibs = JSON.parse(response.data.result)) : (this.pythonEnvLibs = JSON.parse(response.data.result))
                    this.libListVisible = true
                })
                .catch(() => {})
        },
        updateValueFromLabel(optionsArray, fieldToUpdate, updatedField) {
            const selectedField = optionsArray.find((option) => option.label === updatedField)
            selectedField ? (this.dataset.pythonEnvironment[fieldToUpdate] = selectedField.value) : ''
        },
        resetPythonEnv() {
            this.dataset.pythonEnvironment = {
                label: '',
                value: ''
            }
        }
    }
})
